import { render, staticRenderFns } from "./SummarizationBlock.vue?vue&type=template&id=cffa8344&scoped=true"
import script from "./SummarizationBlock.vue?vue&type=script&lang=js"
export * from "./SummarizationBlock.vue?vue&type=script&lang=js"
import style0 from "./SummarizationBlock.vue?vue&type=style&index=0&id=cffa8344&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffa8344",
  null
  
)

export default component.exports